import BaseAuth from '@/constants/Auth'
import {ROL_ASESOR_ID} from '@/constants/models/Role'

class Auth extends BaseAuth {
    constructor (auth) {
        super(auth);
    }
}

export {Auth}
